module.exports = __webpack_public_path__ + "img/b1 (7).2108497e.png";